import React, {useEffect, useState} from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import {TextBoxDataMart} from "./TextBoxDataMart";
import {FxmsData} from "../../../datas/FxData";

export const TextBox = (props) => {

    const [background, setBackground] = React.useState([]);
    const [open, setOpen] = useState(false)
    const [multi, setMulti] = useState(false)
    const [api, setApi] = useState('')
    const [designOptions, setDesignOptions] = useState({
        title:'title',subTitle:'subtitle',bgColor:"#2a2929",fontSize:30,subFontSize:15,titleColor:'#ffffff',subColor:'#ffffff',
        titleAlign:'left',subTitleAlign:'left',content:"98",contentAlign:'right',contentSize:50,contentColor:'#ffffff',contentUnit:'kwh'
    })
    useEffect(()=>{
        if(props.item.fxUiDashbItemAttrs){
            if(props.item.fxUiDashbItemAttrs.length > 0) {
                let newOptions = {}
                for(let key in designOptions){
                    newOptions[key] = props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal
                }
                if(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=="api").attrVal != ''){
                    setApi(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=="api").attrVal)
                }
                setDesignOptions(newOptions)
            }
        }
    },[])

    useEffect(()=>{
        if(api != ""){
            FxmsData.GET(api).then(res=>{
                console.log(res.data)
                setDesignOptions({...designOptions,content:res.data.content})
            })
        }
    },[api])

    const saveCurrentData = () => {
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'api',attrVal:api,attrType:'string'})
        for(let key in designOptions){
            currentData.push({uiNo:props.item.uiNo,attrName:key,attrVal:designOptions[key]+'',attrType:'string'})
        }
        props.save(currentData,props.item.uiNo,props.item.opId)
    }

    return (
        <StyledEngineProvider>
            <div style={{backgroundColor:designOptions.bgColor,height:'inherit'}}>
                {props.editable ? <TextBoxDataMart options={{designOptions,setDesignOptions}} api={setApi} handleCloseAndSave={saveCurrentData}/>: ''}
                <div style={{margin:'10px',fontSize:designOptions.fontSize+'px',color:designOptions.titleColor,textAlign:designOptions.titleAlign}}>{designOptions.title}</div>
                <div style={{margin:'10px',fontSize:designOptions.subFontSize+'px',color:designOptions.subColor,textAlign:designOptions.subTitleAlign}}>{designOptions.subTitle}</div>
                <div style={{margin:'10px',fontSize:designOptions.contentSize+'px',color:designOptions.contentColor,textAlign:designOptions.contentAlign}}>{designOptions.content+ ' '+designOptions.contentUnit}</div>
            </div>

        </StyledEngineProvider>
    )
}